import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Requirements from './Requirements';
import Results from './Results';
import { useSelector } from 'react-redux';
import session from 'containers/App/session';
import Description from './Description';
import { getNewOcc, checkAllInputsFilled, getCSVData } from './utils';
import messages from './messages';
import { FormattedMessage } from 'react-intl';
import ReducedFormActions from './ReducedFormActions';

import './rateChangeImpact.style.css';
import getSymbolFromCurrency from 'currency-symbol-map';

const Container = styled.div`
    padding: 2em;
    margin-bottom: 7em;
`;

const HeadPanel = styled.div`
    padding: 1.5em;
    background-color: white;
    border: 0.1em solid #eaeaea;
    box-shadow: 0 0.2em 0.4em 0 rgba(215, 215, 215, 0.5);
    display: flex;
    flex-direction: row;
`;

const Panel = styled.div`
    padding: 1.5em;
    background-color: white;
    border: 0.1em solid #eaeaea;
    box-shadow: 0 0.2em 0.4em 0 rgba(215, 215, 215, 0.5);
    overflow-y: hidden;
    margin-top: 1em;
`;

const Title = styled.h2`
    font-family: ${({ theme }) => theme.font.title};
    font-size: 1.5625rem;
    color: ${({ theme }) => theme.colour.dark};
    text-align: left;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
`;

const initialState = {
    totalRooms: '',
    currentRate: '',
    proposedRate: '',
    costOfOccupiedRoom: '',
    forecastedOcc: '',
    forecastedActual: '',
    newOccupancy: '',
    addOccupancy: '',
    newRooms: '',
    actualRooms: '',
    direction: '',
};

const RateChangeImpactForm = () => {
    const [formState, setFormState] = useState(initialState);
    const [showResult, setshowResult] = useState(false);
    const [showError, setshowError] = useState(false);

    const currency = useSelector(session.selectors.selectCurrency);
    const roomCount = useSelector(session.selectors.selectRoomCount);
    const propertyName = useSelector(session.selectors.selectPropertyName);

    useEffect(() => {
        setTimeout(() => {
            setshowError(false);
        }, 3000);
    }, [showError]);

    useEffect(() => {
        if (propertyName === 'Right Revenue Hotel') {
            setFormState({ ...formState, totalRooms: '' });
        } else {
            setFormState({ ...formState, totalRooms: roomCount });
        }
    }, [roomCount]);

    const setResultsVisible = () => {
        setshowResult(true);
    };

    const setInput = (key, value) => {
        setFormState({ ...formState, [key]: value });
    };

    const clearForm = () => {
        setFormState(initialState);
        setshowResult(false);
    };

    const onSubmit = async () => {
        const newOccupancy = await getNewOcc(formState);

        const addOccupancy = Math.round(newOccupancy - formState.forecastedOcc).toString();

        const actualRooms = Math.round((formState.totalRooms * addOccupancy) / 100).toString();

        const forecastedActual = Math.round((formState.totalRooms * formState.forecastedOcc) / 100).toString();

        const newRooms = (Number(forecastedActual) + Number(actualRooms)).toString();

        const direction = actualRooms > 0 && addOccupancy > 0 ? 'higher' : 'lower';

        const validate = checkAllInputsFilled(formState);

        const updateState = () => {
            setFormState(() => ({
                ...formState,
                newOccupancy,
                addOccupancy,
                actualRooms,
                forecastedActual,
                newRooms,
                direction,
            }));
            setResultsVisible();
        };

        if (!validate) {
            setshowResult(false);
            setshowError(true);
            return;
        }
        updateState();
    };

    const csvData = getCSVData(formState);
    const currencyIcon = getSymbolFromCurrency(currency);

    const exportedFileName = 'right-revenue-rate-change-impact-calc.csv';

    return (
        <Container className="rateChaImp-main">
            <HeadPanel>
                <Title>
                    <FormattedMessage {...messages.calculatorTitle} />
                </Title>
            </HeadPanel>
            <Panel>
                <Description />
                <Requirements
                    formState={formState}
                    onSubmit={onSubmit}
                    setInput={setInput}
                    currency={currencyIcon}
                    error={showError}
                    showResult={showResult}
                />
                <Results data={formState} showResult={showResult} setInput={setInput} />
            </Panel>
            <ReducedFormActions clearForm={clearForm} csvData={csvData} exportedFileName={exportedFileName} />
        </Container>
    );
};

export default RateChangeImpactForm;
